import React, { useState } from "react";
import TierBtnData from "../../js/tierData";
import Icons from "../../assets/icon/index";
// import CategoriesBtnCom from '../../components/categoriesBtnCom';
// import CategoriesBtnColor from '../../js/categoriesBtnData';
import Navbar from "../../components/navbar";
// import PackageBtn from "../Package";
import Experience from "../../components/experience";
import Footer from "../../components/footer";
import MainHeading from "../../components/mainHeading";
const Package = () => {
  // const [isYearly, setIsYearly] = useState(true);
  // const togglePricing = () => {
  //     setIsYearly(!isYearly);
  // };
  // const userData = useSelector((state) => state.app.userData.userData);
  const [selectedTier, setSelectedTier] = useState(TierBtnData[0]);
  // const [selectedTier, setSelectedTier] = useState(userData?.role === 'fan' ? TierBtnData[0] : userData?.role === 'talent' ? TierBtnData[1] : TierBtnData[2]);
  // const handleButtonClick = (tier) => {
  //     setSelectedTier(tier);
  // };
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <div className="flex justify-center flex-col items-center h-18 sm:h-20 lg:h-36">
          <div className="w-full">
            <MainHeading title={"Pricing Plans"} dis={" "} navigate={"/"} />
            {/* <div className="mt-5 flex justify-center items-center -z-30">
                            <div className="relative xs:gap-2 sm:gap-3 lg:gap-4 inline-flex items-center">
                                <p className="text-secondary font-onestRegular xs:text-sm sm:text-sm lg:text-base">Monthly</p>
                                <div
                                    onClick={togglePricing}
                                    className={`w-16 h-8 xs:w-14 xs:h-6 sm:w-[60px] sm:h-7 rounded-full border-2 bg-primary border-[#1DCCA8] relative cursor-pointer transition-all`}
                                >
                                    <div
                                        className={`w-6 h-6 xs:w-4 xs:h-4 sm:w-5 sm:h-5 bg-secondary text-white rounded-full absolute top-[2px] left-[2px] transition-transform duration-300 ${isYearly ? 'transform translate-x-8' : ''
                                            }`}
                                    ></div>
                                </div>
                                <p className="text-secondary font-onestRegular xs:text-sm sm:text-sm lg:text-base">Yearly</p>
                                <p className="text-secondary xs:text-sm sm:text-sm lg:text-base font-caveatRegular">(Save 20%)</p>
                            </div>
                        </div> */}
          </div>
        </div>
        {/* <div className="overflow-x-auto dashboard-scrollbar-cat">
                <div className="flex xs:gap-x-2 sm:gap-x-3 items-center justify-center mx-auto w-max sm:mb-2.5 xs:mb-3">
                    {TierBtnData.map((value, index) => (
                        <CategoriesBtnCom
                            key={index}
                            onClick={() => handleButtonClick(value)}
                            btnTitle={value?.btntitle}
                            // disabled={selectedTier.id !== value?.id || value?.disabled}
                            comingSoon={value?.comingSoon}
                            bgColor={
                                selectedTier.id === value?.id
                                    ? CategoriesBtnColor[index % CategoriesBtnColor.length].activeBgColor
                                    : CategoriesBtnColor[index % CategoriesBtnColor.length].bgColor
                            }
                            btnIcon={value?.roleIcons}
                            CateclassName={`xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:duration-500 before:ease-out ${selectedTier.id !== value?.id || value?.disabled
                                ? ''
                                : 'hover:shadow-orange-600 before:bg-orange-600 hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64'
                                }`}
                            fontClassname={"font-onestSemiBold"}
                            iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                            alt={value?.btntitle}
                        />
                    ))}
                </div>
            </div> */}
        {/* Display Award Data */}
        {selectedTier?.award && (
          <div className="mt-8 grid grid-cols-2 gap-8 lg:w-full xs:grid-cols-1 sm:pt-8 lg:pt-10">
            {selectedTier?.award?.map((awardItem) => (
              <div
                key={awardItem?.id}
                className="py-3 pl-3 sm:py-3 sm:pl-3 lg:py-5 lg:pl-5 xl:py-10 xl:pl-10 mt-5 sm:mt-5 lg:mt-16 xl:mt-16 relative lg:w-full rounded-3xl flex justify-start items-start"
                style={{ backgroundColor: awardItem?.bgColor }}
              >
                <div className="z-20">
                  <h2 className="text-primary font-unboundedBold xs:text-base sm:text-lg lg:text-2xl uppercase">
                    {awardItem?.title}
                  </h2>
                  <div className="flex items-center">
                    {awardItem?.isComingSoon ? (
                      <>
                        <div className="text-primary font-onestBold xs:text-2xl sm:text-2xl ">
                          COMING SOON
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex items-center">
                          <h3 className='text-primary font-onestBold xs:text-2xl sm:text-2xl  xl:text-5xl after:xs:text-xs after:xl:text-lg after:sm:text-xs after:lg:text-sm lg:text-4xl relative after:absolute after:bottom-1 after:left-1 xs:pl-3 sm:pl-3.5 lg:pl-4 after:content-["$"]'>
                            {awardItem?.pricing}
                          </h3>
                          <span
                            className={`text-primary font-onestBold xs:text-lg sm:text-xl ${
                              awardItem?.isPkR ? "px-1" : ""
                            }`}
                          >
                            {awardItem?.isPkR && awardItem?.isPkR}
                          </span>
                        </div>
                        <div>
                          <p className="text-primary font-onestMedium xl:leading-4 lg:leading-3 xl:text-sm lg:text-sm sm:text-xs sm:leading-3 xs:text-xs xs:pl-[1px] xs:leading-3">
                            {awardItem?.pricingperuser}
                          </p>
                          <p className="text-primary font-onestMedium xl:leading-4 lg:leading-3 xl:text-sm lg:text-sm sm:text-xs sm:leading-3 xs:text-xs xs:pl-[1px] xs:leading-3">
                            {awardItem?.pricingpermonth}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="sm:w-64 lg:w-72 xl:w-96">
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1 ">
                      {awardItem?.point1 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point1}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point2 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point2}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point3 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point3}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point4 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point4}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point5 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point5}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point6 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point6}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point7 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point7}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point8 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point8}
                      </p>
                    </div>
                    <div className="flex items-center sm:gap-1 lg:gap-1 xs:gap-1 xs:py-[2px] lg:py-[2px] sm:py-[2px] xl:py-1">
                      {awardItem?.point9 && (
                        <img
                          className="w-5 h-5"
                          src={Icons.pointsIcon}
                          alt="pointsIcon"
                        />
                      )}
                      <p className="text-primary xl:text-base xs:text-sm xs:leading-4 sm:text-sm sm:leading-4 lg:text-sm font-onestRegular">
                        {awardItem?.point9}
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-center items-center xs:w-48 xs:m-auto xs:h-8 sm:w-28 sm:h-7 lg:w-32 lg:h-8 xl:w-36 xl:h-10 rounded-full bg-primary xs:mt-2 sm:mt-1 xl:mt-4 lg:mt-2    ">
                    <p className="text-secondary font-onestRegular xs:text-sm sm:text-sm lg:text-sm xl:text-base">
                      {awardItem?.btntitle}
                    </p>
                  </div>
                </div>
                {/* <img src={awardItem?.awardImg} alt="Award" className="w-10/12 z-10 sm:w-full lg:w-full xl:w-11/12 2xl:w-9/12 3xl:w-3/5 absolute bottom-0 right-0" /> */}
                <img
                  src={awardItem?.awardImg}
                  alt="Award"
                  className={`w-5/12 z-10 absolute bottom-0 ${awardItem?.awardPosition}`}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="xs:pt-4">
        <Experience />
      </div>
      <Footer />
    </div>
  );
};

export default Package;
